/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { CreateApplicationDraft200ResponseData } from './CreateApplicationDraft200ResponseData'
import {
  CreateApplicationDraft200ResponseDataFromJSON,
  CreateApplicationDraft200ResponseDataFromJSONTyped,
  CreateApplicationDraft200ResponseDataToJSON,
} from './CreateApplicationDraft200ResponseData'

/**
 *
 * @export
 * @interface CreateApplicationDraft200Response
 */
export interface CreateApplicationDraft200Response {
  /**
   *
   * @type {boolean}
   * @memberof CreateApplicationDraft200Response
   */
  status: boolean
  /**
   *
   * @type {CreateApplicationDraft200ResponseData}
   * @memberof CreateApplicationDraft200Response
   */
  data: CreateApplicationDraft200ResponseData
}

/**
 * Check if a given object implements the CreateApplicationDraft200Response interface.
 */
export function instanceOfCreateApplicationDraft200Response(
  value: object
): value is CreateApplicationDraft200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function CreateApplicationDraft200ResponseFromJSON(
  json: any
): CreateApplicationDraft200Response {
  return CreateApplicationDraft200ResponseFromJSONTyped(json, false)
}

export function CreateApplicationDraft200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateApplicationDraft200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: CreateApplicationDraft200ResponseDataFromJSON(json['data']),
  }
}

export function CreateApplicationDraft200ResponseToJSON(
  value?: CreateApplicationDraft200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: CreateApplicationDraft200ResponseDataToJSON(value['data']),
  }
}
